import { action, observable, runInAction } from 'mobx';
import ChangelogService from '../services/ChangelogService';

class ChangelogStore {
  @observable changes = [];
  @observable numeroNovidades;

  changelogService = new ChangelogService();

  @action fetchChangelog = async () => {
    const changes = await this.changelogService.consultar();
    runInAction(() => {
      this.changes = changes;
    });
  }

  @action fetchNumeroNovidades = async () => {
    const numero = await this.changelogService.contar();
    runInAction(() => {
      this.numeroNovidades = numero;
    });
  }

  @action updateCookie = async () => {
    await this.changelogService.updateCookie();
    runInAction(() => {
      this.numeroNovidades = 0;
    });
  }
}

export default ChangelogStore;
